export default "__VITE_ASSET__a4288f3f__"